import { safeArray } from "@/helpers/functions/ArrayHelpers";

export const enumMap = Object.freeze({
  PENDENTE: "PENDENTE",
  ERRO: "ERRO",
  AGUARDANDO_PAGAMENTO: "AGUARDANDO_PAGAMENTO",
  PAGO: "PAGO",
  PROCESSADO: "PROCESSADO",
  CANCELADO: "CANCELADO",
  INADIMPLENTE: "INADIMPLENTE",
  VENCIDO: "VENCIDO",
  REJEITADO: "REJEITADO",
  ESTORNADO: "ESTORNADO",
});

export const statusMap = Object.freeze({
  [enumMap.PENDENTE]: "bg-info-custom text-white",
  [enumMap.ERRO]: "bg-danger text-white",
  [enumMap.AGUARDANDO_PAGAMENTO]: "bg-warning text-white",
  [enumMap.PAGO]: "bg-primary text-white",
  [enumMap.PROCESSADO]: "bg-success text-white",
  [enumMap.CANCELADO]: "bg-danger text-white",
  [enumMap.INADIMPLENTE]: "bg-danger text-white",
  [enumMap.VENCIDO]: "bg-danger text-white",
  [enumMap.REJEITADO]: "bg-danger text-white",
  [enumMap.ESTORNADO]: "bg-info text-white",
});

export const labelMap = Object.freeze({
  [enumMap.PENDENTE]: "Pendente",
  [enumMap.ERRO]: "Erro",
  [enumMap.AGUARDANDO_PAGAMENTO]: "Aguardando pagamento",
  [enumMap.PAGO]: "Pago",
  [enumMap.PROCESSADO]: "Processado",
  [enumMap.CANCELADO]: "Cancelado",
  [enumMap.INADIMPLENTE]: "Vencido",
  [enumMap.VENCIDO]: "Vencido",
  [enumMap.REJEITADO]: "Rejeitado",
  [enumMap.ESTORNADO]: "Estornado",
});

/**
 * @param {keyof enumMap} value
 */
export function getParsedStatus(value) {
  const currentStatus = statusMap[value] || statusMap[enumMap.ERRO];
  const currentLabel = labelMap[value] || labelMap[enumMap.ERRO];

  return {
    class: currentStatus,
    label: currentLabel,
  };
}

/**
 * @typedef {typeof enumMap[keyof typeof enumMap]} TValuesEnum
 */

/**
 * @param {TValuesEnum} source
 * @param {TValuesEnum | TValuesEnum[]} value
 */
export function isStatus(source, value) {
  if (Array.isArray(value)) return safeArray(value).includes(source);

  return Object.is(source, value);
}
